<style scoped>

</style>
<template>
  <div style="width: 50%;background-color: #2c3e50;position: relative;left: 25%;padding: 3%" ><div v-html="txt"></div></div>
  <div style="width: 50%;position: relative;left: 25%;padding: 3%" >
  <el-input></el-input>{{id}}
  </div>

</template>


<script>
export default {
  name: "NovelContent",
  data(){
    return{
      txt:"",
      id:""
    }
  },
  methods:{

  },

  mounted() {



      var Chaptercontent = JSON.parse(localStorage.getItem('chaptercontent'));
      var ChapterId = localStorage.getItem('chapterId');



    this.txt=Chaptercontent;
    this.id=ChapterId;
  }
}
</script>
